import { render, staticRenderFns } from "./SaveNewDataRecord.vue?vue&type=template&id=f8debac6"
import script from "./SaveNewDataRecord.vue?vue&type=script&lang=js"
export * from "./SaveNewDataRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports